import { createFrontendModule } from '@backstage/frontend-plugin-api';
import type { FrontendModule } from '@backstage/frontend-plugin-api';
import { SidebarContent } from './Sidebar';

export const navModule: FrontendModule = createFrontendModule({
  pluginId: 'app',
  extensions: [SidebarContent],
});
